import { render } from "./EmailDesigner.vue?vue&type=template&id=fbb1a846"
import script from "./EmailDesigner.vue?vue&type=script&lang=js"
export * from "./EmailDesigner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__